import { jsx } from "react/jsx-runtime";
import classNames from "classnames";
import React__default from "react";
import animationStyles from "../../../../animations/grid-animations.module.scss";
import { useConfig } from "../../../../contexts/config-context.js";
import { Focusable } from "../form/focusable.js";
import { getGridStyle } from "./grid-options.js";
import styles from "./grid.module.scss";
const Grid = ({
  items,
  layout,
  isRTL
}) => {
  const { isMobile, enableAnimations } = useConfig();
  const reactElementsByRow = getReactElementsByRow(items);
  return /* @__PURE__ */ jsx("div", { className: styles.container, dir: isRTL ? "rtl" : "", children: reactElementsByRow.map((rowData, index) => {
    const fieldId = rowData.firstFieldId;
    const key = isMobile && fieldId || index;
    return /* @__PURE__ */ jsx(Focusable, { fieldId, children: /* @__PURE__ */ jsx(
      "div",
      {
        style: getGridStyle({ layout }),
        className: classNames(styles.grid, styles.column, {
          [animationStyles.animations]: enableAnimations
        }),
        children: rowData.elements
      },
      key
    ) }, fieldId);
  }) });
};
function getReactElementsByRow(items) {
  const reactElementsByRow = items.reduce((result, item) => {
    const row = item.layout.row;
    const element = React__default.cloneElement(item.component, { key: item.id });
    if (result[row]) {
      result[row].elements.push(element);
    } else {
      result[row] = {
        elements: [element],
        firstFieldId: item.id
      };
    }
    return result;
  }, []);
  return reactElementsByRow;
}
export {
  Grid
};
//# sourceMappingURL=grid.js.map
